module.exports = __webpack_public_path__ + "img/Restaurants_Recall_3_Set.c8176dcc.png";